import { getFullFieldPath } from '../../utils';

import { W9_TAB_KEY } from './constants';

export const getFullW9Path = (fieldId) => getFullFieldPath(W9_TAB_KEY, fieldId);
